import axios from "axios";

export interface AffiliateAuthorizationResponse {
  valid: boolean;
  message: string;
  affiliateGuid: string;
  affiliateName: string;
  entityInherit: boolean;
}

export function getAffiliateById(guid: string) {
  return axios({
    method: "GET",
    url: `/api/Affiliate/${guid}/summary`
  });
}

export function getAffiliateAuthorizations(individualGuid: string) {
  return axios.get<AffiliateAuthorizationResponse[]>(`/api/Affiliate/authorizations/${individualGuid}`);
}

export function addAffiliateAuthorization(individualGuid: string, affiliateGuid: string) {
  return axios.post<AffiliateAuthorizationResponse>(`/api/Affiliate/authorizations/${individualGuid}/${affiliateGuid}`);
}

export function removeAffiliateAuthorization(individualGuid: string, affiliateGuid: string) {
  return axios.delete(`/api/Affiliate/authorizations/${individualGuid}/${affiliateGuid}`);
}

export function updateEntityInherit(individualGuid: string, affiliateGuid: string, entityInherit: boolean) {
  return axios.patch(
    `/api/Affiliate/authorizations/${individualGuid}/${affiliateGuid}/entity-inherit`,
    entityInherit,
    { headers: { 'Content-Type': 'application/json' } }
  );
}

export function searchAffiliates(affiliateNbr: string) {
  return axios.post('/api/Affiliate/search', {
    affiliateName: '',
    locationStateAbr: '',
    affiliateNbr,
    affiliateTypeId: '',
  });
}
